import { convertFirebaseTimestampToDate } from '@creator/ui/utils/date-utils';
import { getPost, getPostComment } from '@src/model/upvote/helpers';

export const getBasicPostEventData = (postId: string) => {
    const post = getPost(postId);
    if (!post) throw new Error(`[posts/analytics] post with id ${postId} not found`);

    return {
        postId,
        primaryAuthorId: post.publisherName,
        primaryAuthor: post.publisherProfileName || post.publisherName,
        originalPublishDate: convertFirebaseTimestampToDate(post.createdAt).toISOString(),
    };
};
